import React, {useEffect, useState} from 'react';

/* bootstrap */
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

// styling
import { LEFT_MARGIN } from '../../../styles/spacing';

import CircleLogo from '../../../assets/images/logos/blue-circle.png';

// responsive page
import { useMediaQuery } from 'react-responsive'

// firebase
import { logout } from '../../../services/firebase';

// custom components
import { Button } from '../index'

// redux
import { useSelector, useDispatch} from 'react-redux';
import { LogoutUser, selectUserStatus, selectUserError, selectUser } from '../../../redux/slices/user';

// navigation
import { useNavigate } from 'react-router-dom';

const CustomNavbar = (props) => {

    // nav
    const navigate = useNavigate();

    // redux
    const dispatch = useDispatch()
    const user = useSelector(selectUser);
    const userStatus = useSelector(selectUserStatus);
    const errorFlag = useSelector(selectUserError);

    // responsiviness
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    // handle button press
    const handleLog = () => {
        if(user){
            dispatch(LogoutUser())
        }
        else {
            console.log('here')
            navigate('/login');
        }
    }

    return (
        <Row>
            { !isTabletOrMobile && 
            <Col xs={2} />
            }
            <Col>
                <Navbar expand='lg'>
                    <Navbar.Brand href='/'>
                        <img
                            src={CircleLogo}
                            width="40px"
                            height="40px"
                            className="d-inline-block align-top"
                            alt=""
                            style={{marginLeft:LEFT_MARGIN}}
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                                
                            <Nav.Link href="/" style={{
                                fontWeight: window.location.pathname == '/' ? '700' : null
                            }}>Home</Nav.Link>
                            <Nav.Link href="/introduction" style={{
                                fontWeight: window.location.pathname == '/introduction' ? '700' : null
                            }}>Introduction</Nav.Link>
                            <Nav.Link href="/getting-started" style={{
                                fontWeight: window.location.pathname == '/getting-started' ? '700' : null
                            }}>Getting Started</Nav.Link>

                            <NavDropdown title="More" id="navbarScrollingDropdown">
                                <NavDropdown.Item href="https://prmassist.com">PRM Assist</NavDropdown.Item>
                                <NavDropdown.Item href="https://prmassist.com/login">PRM Portal</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>


                    <Navbar.Toggle />
                    
                    {/* Logout Button */}
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text>
                            <Button status={userStatus} onClick={handleLog}>{ user ? 'Log out' : 'Log in'}</Button>
                            {
                                errorFlag && errorFlag.length > 0 && (
                                    <p style={{color:'red', marginLeft:6}} className="text-danger">{errorFlag}</p>
                                )
                            }
                        </Navbar.Text>
                    </Navbar.Collapse>

                </Navbar>
            </Col>
        </Row>
    );
};

export default CustomNavbar;
